import React from 'react';
import {Navigate, Route, Routes} from 'react-router';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import AccessDeniedPage from './pages/AccessDeniedPage';
import ProtectedRoute from './ProtectedRoute';
import {useAuthContext} from './contexts/auth.context';
import InitiateTransactionPage from './pages/InitiateTransactionPage';
import VerifyTransactionPage from './pages/VerifyTransactionPage';
import JWSValidationPage from './pages/JWSValidationPage';
import WebAuthnPage from './pages/WebAuthnPage';

const AppRoutes: React.FC = () => {
  const auth = useAuthContext();

  const isAuthenticated = auth.user != null;
  const authenticationPath = '/login';

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/401" element={<AccessDeniedPage />} />
      <Route path="/webauthn" element={<WebAuthnPage />} />

      <Route path="/" element={<Navigate to="/checkout" replace />} />

      <Route
        path="/checkout"
        element={
          <ProtectedRoute
            isAuthenticated={isAuthenticated}
            authenticationPath={authenticationPath}
          >
            <InitiateTransactionPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/jws"
        element={
          <ProtectedRoute
            isAuthenticated={isAuthenticated}
            authenticationPath={authenticationPath}
          >
            <JWSValidationPage />
          </ProtectedRoute>
        }
      />

      <Route path="/verify" element={<VerifyTransactionPage />} />

      <Route path="/checkout2" element={<InitiateTransactionPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
